"use strict";

var _slicedToArray = require("/home/runner/work/react-nexys-boilerplate/react-nexys-boilerplate/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var styles_1 = require("@material-ui/core/styles");

var List_1 = __importDefault(require("@material-ui/core/List"));

var ListItem_1 = __importDefault(require("@material-ui/core/ListItem"));

var ListItemIcon_1 = __importDefault(require("@material-ui/core/ListItemIcon"));

var ListItemText_1 = __importDefault(require("@material-ui/core/ListItemText"));

var Checkbox_1 = __importDefault(require("@material-ui/core/Checkbox"));

var useStyles = styles_1.makeStyles(function (theme) {
  return {
    root: {
      width: '100%',
      maxWidth: 360,
      backgroundColor: theme.palette.background.paper
    }
  };
});

var Loader = function Loader(props) {
  var isLoading = props.isLoading;

  if (isLoading !== true) {
    return null;
  }

  return react_1.default.createElement("p", null, react_1.default.createElement("i", null, "is being updated"));
};

var ListUnit = function ListUnit(props) {
  var i = props.i,
      value = props.value,
      updatePromise = props.updatePromise;

  var _react_1$default$useS = react_1.default.useState(!!value.assigned),
      _react_1$default$useS2 = _slicedToArray(_react_1$default$useS, 2),
      isChecked = _react_1$default$useS2[0],
      setChecked = _react_1$default$useS2[1];

  var _react_1$default$useS3 = react_1.default.useState(false),
      _react_1$default$useS4 = _slicedToArray(_react_1$default$useS3, 2),
      isLoading = _react_1$default$useS4[0],
      setLoading = _react_1$default$useS4[1];

  var _react_1$default$useS5 = react_1.default.useState(value.assigned),
      _react_1$default$useS6 = _slicedToArray(_react_1$default$useS5, 2),
      assigned = _react_1$default$useS6[0],
      setAssigned = _react_1$default$useS6[1];

  var handleClick = function handleClick() {
    if (isLoading === true) {
      console.warn('this action is blocked since the promise is still working');
    }

    setLoading(true);
    updatePromise(value.id, assigned).then(function (x) {
      setChecked(!isChecked);
      setLoading(false);
      setAssigned(Boolean(x));
    });
  };

  var labelId = "checkbox-list-label-".concat(i);
  return react_1.default.createElement(ListItem_1.default, {
    key: i,
    role: undefined,
    dense: true,
    button: true,
    onClick: handleClick
  }, react_1.default.createElement(ListItemIcon_1.default, null, react_1.default.createElement(Checkbox_1.default, {
    edge: "start",
    checked: isChecked,
    tabIndex: -1,
    disableRipple: true,
    inputProps: {
      'aria-labelledby': labelId
    }
  })), react_1.default.createElement(ListItemText_1.default, {
    id: labelId,
    primary: value.name
  }), react_1.default.createElement(Loader, {
    isLoading: isLoading
  }));
};

var ListAssign = function ListAssign(props) {
  var data = props.data,
      updatePromise = props.updatePromise;
  var classes = useStyles();
  return react_1.default.createElement(List_1.default, {
    className: classes.root
  }, data.map(function (value, i) {
    return react_1.default.createElement(ListUnit, {
      key: i,
      i: i,
      value: value,
      updatePromise: updatePromise
    });
  }));
};

exports.default = ListAssign;